// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDCA5-f3OYLqE09w50N8dzd2Anebhybazo", // IMPORTANT: Consider using environment variables for keys
  authDomain: "sterk-aan-het-werk.firebaseapp.com",
  projectId: "sterk-aan-het-werk",
  storageBucket: "sterk-aan-het-werk.firebasestorage.app",
  messagingSenderId: "533854119480",
  appId: "1:533854119480:web:d7cd12525c51b7a871a8cd",
  measurementId: "G-36633BH1GZ"
};

// Initialize Firebase
// Check if Firebase app already exists to avoid re-initialization
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

const auth = getAuth(app);
const db = getFirestore(app);
let analytics;
if (typeof window !== 'undefined') {
  // Initialize Analytics only on the client side
  analytics = getAnalytics(app);
}

export { app, auth, db, analytics }; 